import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Container, Form } from "../../styles/GlobalStyles";
import {
  Content,
  CardHeader,
  CategoryTitle,
  CustomButton,
  FormSection,
  DisabledCustomButton,
  TermsText,
  LinkText,
} from "./styled";

import api from "../../api/axios";
import WhatsappButton from "../../components/WhatsappButton";
import { toast } from "react-toastify";
import { Checkboxes } from "../../components/Checkboxes";

export default function Candidatar() {
  const { paramId } = useParams();

  const [skills, setSkills] = useState([]);

  const [professionalData, setProfessionalData] = useState({});
  const [oportunity, setOportunity] = useState({});

  const [isSendingForm, setIsSendingForm] = useState(false);

  const [error, setError] = useState("");

  const getOportunity = async () => {
    try {
      const oportunityData = await api.get(`/oportunity/search/${paramId}`);
      setOportunity(oportunityData.data);

      const skillsData = await api.get(`/skill/list`);
      const skillsOportunity = [];

      skillsData.data?.forEach((skill) => {
        if (oportunityData.data?.skills?.includes(skill.name)) {
          skillsOportunity.push(skill);
        }
      });

      setSkills(skillsOportunity);
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro: ", err);
    }
  };

  const getProfessional = async () => {
    try {
      const res = await api.get("/professional/search-by-user");
      setProfessionalData(res.data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setIsSendingForm(true);

    try {
      await api.put("/professional/update/" + professionalData._id, {
        skills: professionalData.skills,
      });

      const resApply = await api.post("/application/apply", {
        id: paramId,
      });

      if (resApply.status === 200) toast.success("Candidatura enviada!");
    } catch (err) {
      toast.error("Erro: " + err.response?.data?.message);
      setError(err.response?.data?.message);
      setIsSendingForm(false);
      return;
    }

    window.location.href = "https://ticoopbrasil.coop.br/oportunidades-ti/";
  }

  const handleBackButtonClick = () => {
    window.location.href = "https://ticoopbrasil.coop.br/oportunidades-ti/";
  };

  useEffect(() => {
    getOportunity();
    getProfessional();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Content>
      <WhatsappButton />
      <Container>
        <CardHeader>
          <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
            <img
              src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
              alt="Logo Ticoop"
            />
          </a>
          <CustomButton onClick={handleBackButtonClick}>
            Voltar as oportunidades
          </CustomButton>
        </CardHeader>
        <Form>
          <FormSection>
            <CategoryTitle>Sobre a Oportunidade</CategoryTitle>

            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <span>{oportunity.cargo}</span>
              <span>{`Profissional: ${professionalData.name}`}</span>
            </div>

            <TermsText>
              {"Marque as opções que você possui conhecimento:"}
            </TermsText>
            <div style={{ width: "100%" }}>
              <Checkboxes
                options={skills}
                data={professionalData}
                setData={setProfessionalData}
                re
              />
            </div>
          </FormSection>
          <div className="erro">{error}</div>
          <TermsText>
            Ao me inscrever, concordo com os{" "}
            <LinkText
              href="https://ticoopbrasil.coop.br/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
            >
              Termos e Condições
            </LinkText>{" "}
            do site
          </TermsText>
          {isSendingForm ? (
            <DisabledCustomButton onClick={(e) => e.preventDefault()}>
              Candidatar
            </DisabledCustomButton>
          ) : (
            <CustomButton type="submit" onClick={handleSubmit}>
              Candidatar
            </CustomButton>
          )}
        </Form>
      </Container>
    </Content>
  );
}
